// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K4DT","col":"styles_col__3wYJF","actions":"styles_actions__19ix4","conflict":"styles_conflict__2sxEI"};